import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut, UserCircle, LayoutDashboard, BookMarked, Sparkles } from "lucide-react";

export default function NavBar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-[#F5F3ED]/90 backdrop-blur-md border-b border-[#E5E1D8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-wrap items-center justify-between gap-y-3">
        <Link to={user ? "/catalog" : "/"} className="flex items-center gap-2" data-testid="nav-logo">
          <span className="font-serif text-2xl tracking-tight text-[#2B3029]">matchappart</span>
          <span className="text-[10px] tracking-[0.25em] uppercase text-[#8C6C50] font-semibold mt-1 hidden sm:inline">privé</span>
        </Link>
        <nav className={`flex items-center gap-4 sm:gap-6 ${user ? "w-full md:w-auto overflow-x-auto whitespace-nowrap" : ""}`}>
          <Link to="/demande" className="text-sm text-[#8C6C50] hover:text-[#6B5B49] transition-colors flex items-center gap-1 font-medium whitespace-nowrap" data-testid="nav-custom-request">
            <Sparkles className="w-4 h-4 hidden sm:inline" /> <span className="sm:hidden">Sur mesure</span><span className="hidden sm:inline">Demande sur mesure</span>
          </Link>
          {user && (
            <>
              <Link to="/catalog" className="text-sm hover:text-[#8C6C50] transition-colors" data-testid="nav-catalog">
                Catalogue
              </Link>
              <Link to="/reservations" className="text-sm hover:text-[#8C6C50] transition-colors flex items-center gap-1" data-testid="nav-reservations">
                <BookMarked className="w-4 h-4" /> Mes demandes
              </Link>
              {user.role === "admin" && (
                <Link to="/admin" className="text-sm hover:text-[#8C6C50] transition-colors flex items-center gap-1" data-testid="nav-admin">
                  <LayoutDashboard className="w-4 h-4" /> Admin
                </Link>
              )}
              <div className="flex items-center gap-2 pl-4 sm:pl-6 border-l border-[#E5E1D8] ml-auto md:ml-0">
                <UserCircle className="w-5 h-5 text-[#666]" />
                <span className="text-sm text-[#666] hidden md:inline" data-testid="nav-user-email">{user.email}</span>
                <button
                  onClick={async () => { await logout(); nav("/"); }}
                  className="ml-2 p-2 rounded-md hover:bg-[#EFECE5] transition-colors"
                  title="Se déconnecter"
                  data-testid="nav-logout-btn"
                >
                  <LogOut className="w-4 h-4" />
                </button>
              </div>
            </>
          )}
          {!user && (
            <Link
              to="/login"
              className="btn-primary px-4 sm:px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap"
              data-testid="nav-login-link"
            >
              Se connecter
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
